import React from 'react';
import PropTypes from 'prop-types';

import { HELP_NUMBER } from 'dpl/shared/constants/breeder_app';
import { isMobileUA } from 'dpl/shared/utils';
import Drawer, {
  DrawerItem,
  DrawerItemTitle,
  DrawerItemContent
} from 'dpl/common/components/Drawer';
import Icon from 'dpl/common/components/Icon';

const arrowSize = isMobileUA() ? '24px' : '36px';

export default function FaqsSection({ faqItems, title, withHelpNumber }) {
  return (
    <div className="BreederJoinFaqsSection">
      <h3 className="heading-6 heading-4-lg heading-3-xl stone-700 mb4 mb8-lg tc">
        {title}
      </h3>

      <Drawer>
        {faqItems.map(
          ([faqTitle, faqDescription]) =>
            faqTitle &&
            faqDescription && (
              <DrawerItem
                className="bb bw1 b--light-purple"
                itemKey={faqTitle}
                key={faqTitle}
              >
                <DrawerItemTitle
                  arrowClassName="ml2 stone-700"
                  arrowSize={arrowSize}
                >
                  <p className="pv2 flex items-center f5-lg fw-medium stone-700">
                    {faqTitle}
                  </p>
                </DrawerItemTitle>
                <DrawerItemContent>
                  <p
                    className="mb3"
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{ __html: faqDescription }}
                  />
                </DrawerItemContent>
              </DrawerItem>
            )
        )}
        {withHelpNumber && (
          <div className="flex pv8 align-items-center">
            <Icon name="general-questions" height="48px" width="48px" />
            <div className="ml4">
              <p className="f3 f4-lg fw-medium">Still have questions?</p>
              <p className="f2 f3-lg pt1">
                Speak to one of our team members by giving us a call at{' '}
                <a className="underline" href={`tel:${HELP_NUMBER}`}>
                  {HELP_NUMBER}
                </a>
                .
              </p>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
}

FaqsSection.propTypes = {
  faqItems: PropTypes.arrayOf(PropTypes.array).isRequired,
  title: PropTypes.string,
  withHelpNumber: PropTypes.bool
};

FaqsSection.defaultProps = {
  title: 'FAQs',
  withHelpNumber: true
};
